var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.121,
    height: 5.811
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.061 4.75l-4-4-4 4",
    fill: "none",
    stroke: "#2e384d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default __webpack_public_path__ + "static/media/chevron-up.8b7e3d48.svg";
export { SvgChevronUp as ReactComponent };